import THDStorageUtils, { SESSION_STORAGE } from '@thd-olt-global/thd-storage-utils';

export const calcArrHasValues = (arr) => {
  if (!arr.length) return true;
  return arr.some((el) => el !== '');
};

export const shouldClearStorage = (calculateObj) => {
  const {
    valueWidths, valueHeights, valueAreas, valueDescription, valueDepths
  } = calculateObj;
  let shouldClearStorageBool = true;

  const depthArrHasNonDefaultVals = valueDepths.some((el) => !['3', ''].includes(el));
  const areaArrHasValues = valueAreas.some((el) => el.value !== '');
  const calcValuesExist = ((calcArrHasValues(valueDescription) || depthArrHasNonDefaultVals
      || calcArrHasValues(valueHeights) || calcArrHasValues(valueWidths) || areaArrHasValues));

  if (calcValuesExist) shouldClearStorageBool = false;

  return shouldClearStorageBool;
};

export const formatStorageKey = (productInfo) => {
  if (!productInfo) return '';
  const { productDepartment = '', classNumber = '' } = productInfo;
  const DCS = `${productDepartment}-${classNumber}`;
  const storageKey = 'PIP-' + DCS;
  return storageKey;
};

export const getStorageObject = (storageKey) => {
  const storageValue = THDStorageUtils.get(SESSION_STORAGE, { key: storageKey });
  const storageObject = storageValue !== 'undefined' ? JSON.parse(storageValue) : null;

  return storageObject;
};

export const saveStorageObject = (storageKey, calculate) => {
  const {
    calcByArea, calcByWidthHeight, step, toggleText, value, valueAreas, valueDescription,
    valueWidths, valueHeights, valueDepths
  } = calculate;
  const storageObj = getStorageObject(storageKey);

  if (!storageObj && shouldClearStorage(calculate)) return;
  if (storageObj && shouldClearStorage(calculate)) {
    THDStorageUtils.remove(SESSION_STORAGE, { key: storageKey });
  } else {
    THDStorageUtils.set(SESSION_STORAGE, {
      key: storageKey,
      value: JSON.stringify({
        calcByArea,
        calcByWidthHeight,
        step,
        toggleText,
        value,
        valueAreas,
        valueDescription,
        valueWidths,
        valueHeights,
        valueDepths
      })
    });
  }
};
